/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'visa': {
    width: 16,
    height: 16,
    viewBox: '0 0 291.8 91',
    data: '<path pid="0" d="M85.1-.3l-23 61.9-2.4-11.8c0 .1.1.2.1.2l-7.9-38.6C50.1 4.5 44.4-.2 36.7-.3H.4L0 1.4c9.9 2.4 19.2 6.7 27.5 12l20.7 77.4H73l36.8-91H85.1zM104.6 90.8H128L142.7-.3h-23.4zM272.9 0h-18.1c-5.6 0-9.8 1.6-12.2 7.3l-34.8 83.5h24.6l6.8-18.1h27.5l3.5 18.2h21.7L272.9 0zm-27 54.5c.5 0 9.4-29.5 9.4-29.5l7.1 29.5h-16.5zM189.9 36.8c-8.2-4-13.2-6.8-13.2-10.9.1-3.8 4.2-7.6 13.5-7.6 7.6-.2 13.2 1.6 17.4 3.4l2.1.9 3.2-19.1c-4.6-1.8-12-3.8-21-3.8-23.1 0-39.4 12-39.5 29.2-.2 12.8 11.6 19.9 20.5 24.1 9.1 4.3 12.1 7.1 12.1 11-.1 5.9-7.3 8.6-14.1 8.6-9.3 0-14.4-1.4-22-4.7l-3.1-1.4-3.3 19.8c5.5 2.4 15.6 4.6 26.1 4.7 24.6 0 40.5-11.8 40.7-30.2.3-10-5.9-17.7-19.4-24z"/>'
  }
})
